import {
  OMSMetricsRequestSchema,
  ShipmentsByCarrierResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getShipmentsByCarrier = {
  name: "getShipmentsByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: ShipmentsByCarrierResponseSchema,
};
